import { useEffect, useState } from "react";

/**
 * Shared viewport-width hook. Inline styles can't carry media queries, so
 * layout switching is done in JS. Returns true when the viewport is narrower
 * than `breakpoint` (default 768px — iPad portrait and below). Pass 1024 for
 * layouts that need to collapse below iPad landscape (the primary tablet).
 */
export function useIsMobile(breakpoint = 768): boolean {
  const [mobile, setMobile] = useState<boolean>(() =>
    typeof window === "undefined" ? false : window.innerWidth < breakpoint
  );
  useEffect(() => {
    const onResize = () => setMobile(window.innerWidth < breakpoint);
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, [breakpoint]);
  return mobile;
}
